import React from 'react';

import RequiresPrintPackageAlert from './RequiresPrintPackageAlert';
import withModal from '../../../../../../../../../components/global/modal/withModal';

export const REQUIRES_PRINT_PACKAGE_ALERT_MODAL =
  'modal/REQUIRES_PRINT_PACKAGE_ALERT';

const RequiresPrintPackageAlertModal = ({ actionProps, ...props }) => {
  const { name } = actionProps ?? {};
  return <RequiresPrintPackageAlert productName={name} {...props} />;
};

export default withModal(RequiresPrintPackageAlertModal, {
  name: REQUIRES_PRINT_PACKAGE_ALERT_MODAL,
  hideHeader: true,
  size: 'sm',
});
